import styled, { createGlobalStyle, css } from 'styled-components';

import { media } from '../../utils';

export const NavPusher = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-width: 100%;
    height: calc(100% - var(--sidebar-top-offset, 0px));
    margin-top: var(--sidebar-top-offset, 0);
    padding-left: var(--sidebar-left-offset, 0);
    overflow: auto;

    transition: padding-left 150ms;

    will-change: padding-left;

    ${media.XS`
        margin-top: 41px;
        padding-left: 0;
    `}
`;

export const StyledSidebarPusher = styled(NavPusher)<{ $compensateScrollbar?: boolean }>`
    margin-top: initial;
    padding-top: var(--sidebar-top-offset, 0);
    padding-right: ${t => (t.$compensateScrollbar ? 'calc(17px - (100vw - 100%))' : undefined)};

    ${media.XS`
        padding-top: 0;
    `}
`;

export const PageWrapper = styled.div`
    width: 100%;
    margin-top: var(--notification-top-offset, 0);

    ${media.XS`
        margin-top: calc(var(--sidebar-top-offset) + var(--notification-top-offset, 0px) + 55px);
    `}
`;

const makeMinHeight = (mobile = false) => {
    const vars = [
        'var(--true-100vh, 100vh)',
        'var(--sidebar-top-offset, 0px)',
        'var(--notification-top-offset, 0px)',
    ];

    if (mobile) {
        vars.push('56px');
    }

    return `calc(${vars.join(' - ')})`;
};

const desktopMinHeight = makeMinHeight();
const mobileMinHeight = makeMinHeight(true);

export const Content = styled.section`
    position: relative;

    width: 100%;
    min-height: ${desktopMinHeight};
    padding-bottom: var(--zendesk-bottom-offset, 0);

    ${media.XS`
        min-height: ${mobileMinHeight};
    `}
`;

export const CustomBg = createGlobalStyle`
    body {
        background: #f1f4f9;
    }
`;

export const Container = styled.main<{ $iframe?: boolean }>`
    padding: var(--spacing-md);

    ${media.SM`
        padding: var(--spacing-md) var(--spacing-sm);
    `}

    ${media.XS`
        padding: var(--spacing-md) var(--spacing-xs);
    `}


    ${t =>
        t.$iframe &&
        css`
            position: absolute;
            inset: 0;

            margin: 0 !important;
            overflow-y: auto;
        
            -webkit-overflow-scrolling: touch;
    `}
`;
